const FAQData = [
  {
    heading: `What's our Refund Policy ?`,
    content: `Once a service has been subscribed to and a payment has been
      made for the same, it can't be canceled or refunded in any
      case. If for some unforeseen reason, the client is not satisfied
      with our services, they may call us to seek direction on future
      calls... `,
    hrefLabel: 'Click to read complete Refund Policy',
    hrefLink: '/refund-policy',
  },
  {
    heading: `What's the Disclaimer ?`,
    content: `Our Disclaimer consists of Data and reports generated by the
      company, Accuracy of the calls, Buying and Selling, Risks
      Involed, Ownership, Past Performance, Licences, User Agreements,
      Services provided, Delays in services & Payments. `,
    hrefLabel: 'Click to read detailed Disclaimer',
    hrefLink: '/disclaimer',
  },
  {
    heading: `What's our Privacy Policy ?`,
    content: `intelisys.app is committed to protecting the privacy of the
      personally-identifiable information that we collect from you as
      you use this website. The scope of our commitment is detailed in
      this privacy policy. By submitting information on the website,
      you agree to our use of such information as described herein. `,
    hrefLabel: 'Click to read complete Policy',
    hrefLink: '/privacy-policy',
  },
  {
    heading: 'What is Disclosure Policy ?',
    content: `The particulars given in the Disclosure Document have been
      prepared in accordance with SEBI (Research Analyst) Regulations,
      2014. `,
    hrefLabel: 'Click to read our Disclosure document',
    hrefLink: '/disclosure',
  },
  {
    heading: 'What are the Terms and Conditions ?',
    content: `Our Terms and conditions include Access of Information, Age
      Restrictions, Maintaining confidentiality, Right to refund,
      Trading Principles and much more. You can view detailed
      information about our Terms and Condition by `,
    hrefLabel: 'Clicking on this link',
    hrefLink: '/terms-condition',
  },
];

export default FAQData;
